module.exports = __webpack_public_path__ + "media/images/icon__point--default-fdfbacadb36862661bc67ff66c96810d.png";